// The app is US-only, so E.164 formatting assumes this. Revisit toE164 before
// launching anywhere else - it cannot infer a country code from a bare number.
export const US_COUNTRY_CODE = "1";

export const US_PHONE_DIGIT_LENGTH = 10;

// Keys must match Partner.name on the server. Unlisted partners fall back to the FutureMoney mark.
export const PARTNER_LOGO_KEYS: Record<string, "halfmoreFutureMoneyGlass" | "manifestFutureMoney"> =
  {
    Halfmore: "halfmoreFutureMoneyGlass",
    Manifest: "manifestFutureMoney",
  };

/**
 * How an Impact (`futuremoney.pxf.io`) click reaches the web app. Impact never shows us its own
 * URL: it redirects to `/auth` and marks the landing URL with `irgwc=1`. `sharedid` is the one
 * custom param it forwards, so partners put the user's phone number in it.
 */
export const IMPACT_CLICK_PARAM = "irgwc";
export const IMPACT_SHARED_ID_PARAM = "sharedid";
